import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'chameleon/packages/blue-book-player/library/button';

const BlueBookButton = forwardRef((props, ref) => {
  const {
    isPrimary,
    isSecondary,
    isBlack,
    isWarning,
    isNaked,
    isInverted,
    ...rest
  } = props;

  return (
    <Button
      {...rest}
      ref={ref}
      isBlueBookPrimary={isPrimary}
      isBlueBookSecondary={isSecondary}
      isBlueBookBlack={isBlack}
      isBlueBookWarning={isWarning}
      isBlueBookNaked={isNaked}
      isBlueBookInverted={isInverted}
      className={`${props.className} inline-flex items-center justify-center`}
    />
  );
});

BlueBookButton.propTypes = {
  isPrimary: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isBlack: PropTypes.bool,
  isWarning: PropTypes.bool,
};

BlueBookButton.defaultProps = {
  isPrimary: false,
  isSecondary: false,
  isBlack: false,
  isWarning: false,
};

export default BlueBookButton;
